<template>
	<div>
		<div
			class="form-checkbox"
			:class="{
				'form-checkbox--error': error,
			}"
		>
			<input
				class="form-checkbox__field"
				type="checkbox"
				:id="uniqueId"
				:name="name"
				:required="required"
				:value="value"
				@change="onChange"
				:checked="checked"
				:disabled="disabled"
			>
			<label
				class="form-checkbox__label"
				:for="uniqueId"
			>
				<span class="form-checkbox__label-box"/>
				<span class="form-checkbox__label-text">
					{{ label }}
					<slot></slot>
				</span>
			</label>
		</div>
		<span
			class="form-checkbox__hint | form-input-hint"
			v-if="hint"
			v-html="hint"
		/>
		<span
			class="form-checkbox__error | form-input-error"
			v-if="error && errorMessage"
			v-html="errorMessage"
		/>
		<span
			class="form-checkbox__success | form-input-success"
			v-if="successMessage"
			v-html="successMessage"
		/>
	</div>
</template>

<script>
export default {
  model: {
		prop: 'checked',
		event: 'input'
	},
	props: {
		name: String,
		label: String,
		required: Boolean,
    value: Number | String,
    checked: Boolean,
		vertical: Boolean,
		disabled: Boolean,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substr(2, 5))}`,
		}
	},
	methods: {
		onChange(e) {
			this.$emit('input', e.target.checked);
		}
	}
}
</script>

<style>

</style>
